module.exports = __webpack_public_path__ + "img/contact.15f70fbb.png";